import './Hero.css';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Typewriter from 'typewriter-effect';
import ScrollSection from '../ScrollSection';
import { Link as ScrollLink } from 'react-scroll';
import { useContent } from '../../context/ContentContext';

function Hero() {
  const { content, loading } = useContent();

  if (loading || !content) return null;

  const { hero } = content;

  return (
    <ScrollSection name="hero">
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{hero.name} — {hero.title}</title>
          <meta name="description" content={`${hero.title} based in San Jose, CA.`} />
        </Helmet>
      </HelmetProvider>
      <div className="hero-container">
        <div className="hero-gradient" />
        <div className="hero-glow" />
        <div className="hero-fade" />
        <div className="hero-content" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
          <h1>{hero.name}</h1>
          <p className="hero-title">{hero.title}</p>
          <div className="typewriter-text">
            <Typewriter
              options={{
                strings: hero.typewriter,
                autoStart: true,
                loop: true,
                deleteSpeed: 15,
                cursor: '_',
              }}
            />
          </div>
          <div className="hero-links">
            <span className="hero-availability">
              <span className="hero-availability-dot"></span>
              {hero.availability}
            </span>
          </div>
          <ScrollLink to="projects" spy={true} smooth={true} duration={500}>
            <button className="cta-button">View My Work</button>
          </ScrollLink>
        </div>
      </div>
    </ScrollSection>
  );
}

export default Hero;
